(() => {
  const build = () => {
    const template = document.getElementById('ProductInstallationFaqTemplate');
    if (!template) return;
    document.querySelectorAll('.product__info-container').forEach(container => {
      if (container.querySelector('.tints-faq')) return;
      const description = container.querySelector('.product-ux__description');
      const original = description?.querySelector('.tints-installation');
      const faq = template.content.firstElementChild.cloneNode(true);
      if (original) {
        const badges = [...original.querySelectorAll(':scope > div > span')];
        const paragraphs = [...original.querySelectorAll(':scope > details > :not(summary)')];
        const setText = (selector, text) => {
          const answer = faq.querySelector(selector + ' .tints-faq__answer');
          const p = document.createElement('p'); p.textContent = text; answer.replaceChildren(p);
        };
        if (badges[0]?.textContent.trim()) {
          setText('[data-faq-time]', badges[0].textContent.trim());
          faq.querySelector('[data-faq-time] [data-faq-preview]').textContent = badges[0].textContent.trim();
        }
        if (badges[1]?.textContent.trim()) {
          setText('[data-faq-difficulty]', badges[1].textContent.trim());
          faq.querySelector('[data-faq-difficulty] [data-faq-preview]').textContent = badges[1].textContent.trim();
        }
        const timingNotes = paragraphs.filter(p => /installation time is an estimate/i.test(p.textContent));
        timingNotes.forEach(p => faq.querySelector('[data-faq-time] .tints-faq__answer').append(p.cloneNode(true)));
        const toolNotes = paragraphs.filter(p => !timingNotes.includes(p));
        if (toolNotes.length) faq.querySelector('[data-faq-tools] .tints-faq__answer').replaceChildren(...toolNotes.map(p => p.cloneNode(true)));
        if (badges.length > 2 && !toolNotes.length) setText('[data-faq-tools]', badges.slice(2).map(b => b.textContent.trim()).join('. '));
        original.remove();
      }
      faq.querySelectorAll('details').forEach(item => item.addEventListener('toggle', () => {
        if (item.open) faq.querySelectorAll('details').forEach(other => { if (other !== item) other.open = false; });
      }));
      const fitment = container.querySelector('.cro-purchase-details');
      if (fitment) fitment.before(faq);
      else if (description) description.before(faq);
      else container.append(faq);
    });
  };
  build();
  document.addEventListener('shopify:section:load', build);
  let queued = false;
  const root = document.querySelector('main');
  if (root) new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; build(); });
  }).observe(root, { childList: true, subtree: true });
})();
